<template>
    <div class="section-helpdesk" :class="color">
        <layout-contained :class="padding">
            <div :class="heading || content ? 'lg:grid lg:grid-cols-3 lg:space-x-16 xl:space-x-24' : ''">
                <div v-if="heading || content">
                    <content-heading
                        v-if="heading"
                        :heading="heading"
                        :headingColor="headingColor"
                        :headingComponent="headingComponent"
                        :marginBottom="content ? 'mb-3 sm:mb-6' : 'mb-0'"
                        :textCentered="textCentered"
                    ></content-heading>
                    <content-text
                        v-if="content"
                        :html="content"
                        :contentColor="contentColor"
                        :textCentered="textCentered"
                    ></content-text>
                </div>
                <div :class="heading || content ? 'mt-8 lg:mt-10 col-span-2' : ''">
                    <content-subheading class="mb-4" heading="Send Message"></content-subheading>
                    <form-helpdesk></form-helpdesk>
                </div>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionHelpdesk',
    props: {
        padding: {
            required: false,
            default: 'py-10 sm:py-14',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: null,
        },
        content: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
};
</script>
